export const administrative_ticket_list = {
  id: "administrative_ticket_list-1",
  default: true,
  roles: [],

  title: "Tickets Administratifs",
  type: "list",
  conf: {
    element: "administrativeTicket",
    headers: [
      "state",
      "criticity",
      "escalateLevel",
      "number",
      "place",
    ],
    filters: {
      state:{
        _parameterType:"value",
        _title:"",
        value:[
          {
            value:"new",
            label:"Nouveau"
          },
          {
            value:"waiting",
            label:"En attente"
          },
          {
            value:"in_progress",
            label:"En cours de progrès"
          }
        ]
      },
    }
  },
  column: 3,
  row: 4
}
